import { ReactNode } from 'react';

import styles from './info-item.module.scss';

interface InfoItemProps {
  label: string;
  value?: ReactNode;
}

export function InfoItem({ label, value = '-' }: InfoItemProps) {
  return (
    <>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.value}>{value}</dd>
    </>
  );
}
